import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex text-sm font-semibold pb-1 text-black"
}
const _hoisted_2 = ["selected"]
const _hoisted_3 = ["value", "selected"]




export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleSelector',
  props: {
  label: {
    type: String,
  },
  items: {
    type: Array,
    required: false,
    default: () => [],
  },
  selected: {
    required: false,
  },
  placeholder: {
    type: String,
  },
  horizontal: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      __props.horizontal
        ? 'flex flex-row items-center gap-2'
        : 'flex flex-col',
    ])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("select", {
      onChange: _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:modelValue', e)),
      class: "border rounded py-1 px-2 w-full leading-tight focus:outline-none cursor-pointer flex items-center h-[38px] relative bg-white"
    }, [
      _createElementVNode("option", {
        disabled: "",
        selected: !__props.selected
      }, _toDisplayString(__props.placeholder ?? "Seleccione una opción"), 9, _hoisted_2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, key) => {
        return (_openBlock(), _createElementBlock("option", {
          key: key,
          value: item.value,
          selected: __props.selected == item.value
        }, _toDisplayString(item.label ?? "-"), 9, _hoisted_3))
      }), 128))
    ], 32)
  ], 2))
}
}

})